export enum FILTER_OPERATOR {
  BLANK = "BLANK",
  NOT_BLANK = "NOTBLANK",
  BETWEEN = "BETWEEN",
  NOT_BETWEEN = "NOTBETWEEN",
  BETWEEN_TWO_DATES = "BETWEENTWODATES",
  NOT_BETWEEN_TWO_DATES = "NOTBETWEENTWODATES",
  EQUALS = "EQUALS",
}